<template>
  <v-master>
    <div class="sm:pt-20 container relative max-w-lg pt-10">
      <v-form
        :data="informations_form"
        :url="$laravel.route('api.users.account.verify_informations')"
        method="patch"
        @success="onSuccess()"
      >
        <h1 class="title-1 mb-8 text-center">
          Verify your information
        </h1>

        <div class="card mb-8">
          <v-input
            v-model="informations_form.birthday"
            type="date"
            name="birthday"
            label="Select your birthday"
            input-class="w-full"
            class="mb-6"
            required
          />

          <v-input-select
            v-model="informations_form.gender"
            name="gender"
            input-class="w-full"
            label="Gender"
            required
          >
            <option
              v-for="(gender,i) in $laravel.user_genders"
              :key="i"
              :value="gender"
            >
              {{ gender.capitalize() }}
            </option>
          </v-input-select>
        </div>

        <button
          type="submit"
          class="btn btn-primary w-full"
        >
          Save
        </button>
      </v-form>
    </div>
  </v-master>
</template>
<script>
export default {
  name: "v-verify-informations",
  data() {
    return {
      informations_form: {
        birthday: this.$dayjs(this.$laravel.user.birthday).format("YYYY-MM-DD"),
        gender: this.$laravel.user.gender,
      }
    };
  },
  methods: {
    onSuccess() {
      //window.location.href= "/app/quiz-tutorial";
      window.location.href= "/app/quiz";
    }
  }
};
</script>
